module.exports = __webpack_public_path__ + "img/send_black_24dp.457ea286.svg";